import { Injectable } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexTitleSubtitle,
  ApexXAxis,
  ApexFill,
  ApexNonAxisChartSeries,
  ApexResponsive
} from "ng-apexcharts";
import { IGraphDisTipo, IGraphEv } from '../models/IResponseCalculos';


export type ColumnChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  title: ApexTitleSubtitle;
};

export type BarChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis
  responsive?: ApexResponsive[];
  tooltip: any;
};

export type PieChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  plotOptions:any;
  colors: any;
};

@Injectable({
  providedIn: 'root'
})
export class ChartHelperService {

  constructor() { }

  public getEvChartOptions(evData: Map<string, IGraphEv>): ColumnChartOptions {
    
    let series: any[] = [];
    let categoriesSplitted: string[] |undefined = [];

    let keys = Array.from(evData.keys())
    categoriesSplitted = evData.get(keys[0])?.categorias;
    categoriesSplitted = categoriesSplitted ? categoriesSplitted : [] 

    keys.forEach((year) => {
      series.push({
        name: year,
        data: evData.get(year)?.values
      })
    })

    return {
      series: series,
      chart: {
        height: 350,
        // width: 1000,
        type: "bar"
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top" // top, center, bottom
          }
        }
      },
      dataLabels: {
        enabled: false,
        formatter: function(val) {
          return "$" + val;
        },
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"]
        }
      },
  
      xaxis: {
        categories: categoriesSplitted,
        position: "top",
        labels: {
          show: true,
          // rotate: 0
          // offsetY: -18
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5
            }
          }
        },
        tooltip: {
          enabled: true,
          offsetY: -35
        }
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          // stops: [50, 0, 100, 100]
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false,
          formatter: function(val) {
            return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
        }
      },
      title: {
        // text: "Monthly Inflation in Argentina, 2002",
        // floating: 0,
        offsetY: 320,
        align: "center",
        style: {
          color: "#444"
        }
      }
    };
  }

  public getPieChartOptions(pieData: any): PieChartOptions {
    let labels: string[] = Object.keys(pieData);
    let series: number[] = [];

    for(let key of labels) {
      series.push(pieData[key]);
    }

    return {
      colors: ['#054EC2', '#00A5CF', '#9FFFCB', '#7AE582', '#21AAFF' ],
      series: series,
      chart: {
        width: 380,
        type: "pie"
      },
      labels: labels,
      plotOptions: {
        dataLabels: {
          enabled: true,
          style: {
              fontSize: "14px",
              fontWeight: "bold",
              colors: ["#FFFFFF"]
          },
          dropShadow: {
            enabled: false,
          }
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            },
            plotOptions: {
              dataLabels: {
                enabled: false
              }
            }
          }
        }
      ]
    };
  }
  

  getProvClientEvChart(evData: IGraphEv): BarChartOptions {
    return  {
      series: [
        {
          name: "",
          data: evData.values
        }
      ],
      chart: {
        type: "bar",
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      tooltip: {
        y: {
          formatter: function(val: any) {
            return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
        }
      },
      dataLabels: {
        enabled: false,
        formatter: function(val) {
          return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      xaxis: {
        categories: evData.categorias,
        labels: {
          show: false,
          formatter: function(val) {
            return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
        }
      },
      yaxis: {
        labels: {
          // minWidth: 500,
          // maxWidth: 500,
          formatter: function(val) {
            return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            xaxis: {
              labels: {
                show: false,
                rotate: 45
              }
            }
          }
        }
      ]
    };
  }
}
